export default __webpack_public_path__ + "static/media/dashboard_bg.fcffbde7.png";